export const APP_SNACKBAR_POSITION = null;
export const APP_SNACKBAR_DURATION = null;
